/* ALYN - keeps the free Ring Sizing Kit in step with the cart.

   Any ring variant whose SKU ends in -SK is a ring whose size has not been
   chosen yet. Whenever one is in the cart we add the $0 Ring Sizing Kit
   alongside it; take the ring away and the kit goes with it, so nobody can
   check out with a free kit on its own.

   UI updates ride the theme's own event system (Horizon): after correcting
   the cart we dispatch 'cart:update' with the rendered sections Shopify
   returns from the mutation itself. cart-items-component morphs the drawer
   in place and cart-icon takes the new count - no page reload.

   Triggers, most to least immediate: the theme's own 'cart:update' events
   (fired when its product form adds to cart), patched fetch/XHR, and a
   visibility-gated poll - the backstop, because the theme captures its own
   reference to fetch before this file loads and can bypass the patches. */
(function () {
  'use strict';

  var KIT_VARIANT_ID = 71120045080829;
  var AWAITING_SIZE = /-SK$/i;
  var CART_WRITE = /\/cart\/(add|change|update|clear)/;
  var SOURCE = 'alyn-kit-cart';

  var syncing = false;

  function cartSectionIds() {
    var ids = [];
    var nodes = document.querySelectorAll('cart-items-component');
    for (var i = 0; i < nodes.length; i++) {
      var id = nodes[i].dataset ? nodes[i].dataset.sectionId : null;
      if (id && ids.indexOf(id) < 0) ids.push(id);
    }
    return ids;
  }

  function post(url, body) {
    var ids = cartSectionIds();
    if (ids.length) body.sections = ids.join(',');
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    });
  }

  function readCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) {
      return r.json();
    });
  }

  function hasRingAwaitingSize(cart) {
    return (cart.items || []).some(function (item) {
      return item.sku && AWAITING_SIZE.test(item.sku);
    });
  }

  function kitLine(cart) {
    var found = null;
    (cart.items || []).forEach(function (item) {
      if (item.variant_id === KIT_VARIANT_ID) found = item;
    });
    return found;
  }

  /* Tell the theme what happened, in its own language. Components that hear
     'cart:update' morph in the provided section HTML, or re-fetch their own
     section when we could not provide it. */
  function notify(sections) {
    return readCart().then(function (cart) {
      document.dispatchEvent(
        new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: cart,
            sourceId: SOURCE,
            data: { source: SOURCE, itemCount: cart.item_count, sections: sections || undefined }
          }
        })
      );
    });
  }

  /* Only act on a confirmed change - reacting to a failed add would retry
     forever. */
  function apply(r) {
    if (!r || !r.ok) return null;
    return r
      .json()
      .then(function (j) {
        return notify(j && j.sections);
      })
      .catch(function () {
        return notify(null);
      });
  }

  function sync() {
    if (syncing) return;
    syncing = true;

    readCart()
      .then(function (cart) {
        var wants = hasRingAwaitingSize(cart);
        var kit = kitLine(cart);

        if (wants && !kit) {
          return post('/cart/add.js', { items: [{ id: KIT_VARIANT_ID, quantity: 1 }] }).then(apply);
        }
        if (wants && kit && kit.quantity !== 1) {
          return post('/cart/change.js', { id: String(KIT_VARIANT_ID), quantity: 1 }).then(apply);
        }
        if (!wants && kit) {
          return post('/cart/change.js', { id: String(KIT_VARIANT_ID), quantity: 0 }).then(apply);
        }
        return null;
      })
      .catch(function () {
        /* A cart is never worth breaking over a free extra. Fail quiet. */
      })
      .then(function () {
        syncing = false;
      });
  }

  /* Instant path: the theme announces its own cart changes on this same
     event. Skip our own announcements or we would ping-pong. */
  document.addEventListener('cart:update', function (e) {
    var d = e && e.detail;
    if (d && d.sourceId === SOURCE) return;
    if (!syncing) sync();
  });

  /* Fast path for anything that does go through window.fetch / XHR. */
  var nativeFetch = window.fetch;
  window.fetch = function () {
    var target = arguments[0];
    var href = typeof target === 'string' ? target : (target && target.url) || '';
    var call = nativeFetch.apply(this, arguments);
    if (!syncing && CART_WRITE.test(href)) {
      call.then(function () { sync(); }, function () {});
    }
    return call;
  };

  var nativeOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (!syncing && typeof url === 'string' && CART_WRITE.test(url)) {
      this.addEventListener('load', function () { sync(); });
    }
    return nativeOpen.apply(this, arguments);
  };

  /* Backstop: poll while the tab is visible. /cart.js is a tiny cached JSON
     read; this is what guarantees the pairing no matter what the theme does. */
  setInterval(function () {
    if (document.visibilityState === 'visible') sync();
  }, 3000);
  window.addEventListener('pageshow', sync);
  window.addEventListener('focus', sync);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }
})();
